var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "message waba-template-message",
      class: ((_obj = {}), (_obj[_vm.float] = true), _obj),
    },
    [
      _c("div", { staticClass: "waba-bubble" }, [
        _c(
          "div",
          { staticClass: "waba-content" },
          [
            _vm.meta.templateType !== "CAROUSEL"
              ? [
                  _vm.meta.headerMediaType &&
                  ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                    _vm.meta.headerMediaType
                  )
                    ? _c("div", { staticClass: "waba-header-media" }, [
                        _vm.meta.headerMediaType === "IMAGE"
                          ? _c("img", {
                              attrs: {
                                src:
                                  _vm.meta.headerMediaURL ||
                                  _vm.getDefaultImage("IMAGE"),
                                alt: "",
                              },
                              on: { error: _vm.onImageError },
                            })
                          : _vm.meta.headerMediaType === "VIDEO"
                          ? _c("video", {
                              attrs: {
                                src: _vm.meta.headerMediaURL || "",
                                controls: "",
                              },
                            })
                          : _vm.meta.headerMediaType === "DOCUMENT"
                          ? _c("div", { staticClass: "waba-document" }, [
                              _vm.meta.headerMediaURL
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.meta.headerMediaURL,
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("description")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Document")]),
                                      _vm._v(" "),
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("download")]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "waba-document-placeholder",
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("description")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Document")]),
                                    ]
                                  ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.meta.limitedTimeOffer && _vm.meta.limitedTimeOffer.text
                    ? _c("div", { staticClass: "waba-lto" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "waba-lto-body" }, [
                          _c("div", { staticClass: "waba-lto-title" }, [
                            _vm._v(_vm._s(_vm.meta.limitedTimeOffer.text)),
                          ]),
                          _vm._v(" "),
                          _vm.meta.limitedTimeOffer.hasExpiration
                            ? _c("div", { staticClass: "waba-lto-expiry" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.formatLtoExpiry(
                                        _vm.meta.limitedTimeOffer.expirationDate
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.meta.headerText
              ? _c("div", { staticClass: "waba-header-text" }, [
                  _vm._v(_vm._s(_vm.meta.headerText)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.meta.body
              ? _c("div", { staticClass: "waba-body" }, [
                  _vm._v(_vm._s(_vm.meta.body)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.meta.footer
              ? _c("div", { staticClass: "waba-footer" }, [
                  _vm._v(_vm._s(_vm.meta.footer)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getCreatedDate()
              ? _c("div", { staticClass: "waba-timestamp" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            content: _vm.getFullTime(),
                            followCursor: true,
                            placement: "top",
                          },
                          expression:
                            "{ content: getFullTime(), followCursor: true, placement: 'top' }",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(_vm.getTime()))]
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.meta.buttons && _vm.meta.buttons.length > 0
          ? _c(
              "div",
              { staticClass: "waba-buttons" },
              [
                _vm._l(_vm.visibleButtons, function (button, i) {
                  return _c(
                    "div",
                    {
                      key: "btn-" + i,
                      staticClass: "waba-btn",
                      class: _vm.getButtonClass(button),
                    },
                    [
                      _vm.getButtonIcon(button)
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.getButtonIcon(button))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(button.text))]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.meta.buttons.length > 3
                  ? _c(
                      "div",
                      {
                        key: "btn-more",
                        staticClass: "waba-btn waba-btn-more",
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("list"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("See all options")]),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.meta.templateType === "CAROUSEL" &&
      _vm.meta.cards &&
      _vm.meta.cards.length > 0
        ? _c(
            "div",
            { ref: "carouselContainer", staticClass: "waba-carousel" },
            [
              _c(
                "div",
                { staticClass: "waba-carousel-track" },
                _vm._l(_vm.meta.cards, function (card, ci) {
                  return _c(
                    "div",
                    { key: "card-" + ci, staticClass: "waba-carousel-card" },
                    [
                      _c("div", { staticClass: "waba-carousel-card-media" }, [
                        !card.headerType || card.headerType === "IMAGE"
                          ? _c("img", {
                              attrs: {
                                src:
                                  card.mediaUrl || _vm.getDefaultImage("IMAGE"),
                                alt: "",
                              },
                              on: { error: _vm.onImageError },
                            })
                          : card.headerType === "VIDEO"
                          ? _c("video", {
                              attrs: { src: card.mediaUrl || "", controls: "" },
                            })
                          : card.headerType === "DOCUMENT"
                          ? _c(
                              "div",
                              { staticClass: "waba-document-placeholder" },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("description"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      card.body || card.sampleText
                        ? _c(
                            "div",
                            { staticClass: "waba-carousel-card-body" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(card.body || card.sampleText) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      card.buttons && card.buttons.length > 0
                        ? _c(
                            "div",
                            { staticClass: "waba-buttons" },
                            _vm._l(card.buttons, function (btn, bi) {
                              return _c(
                                "div",
                                {
                                  key: "card-" + ci + "-btn-" + bi,
                                  staticClass: "waba-btn",
                                  class: _vm.getButtonClass(btn),
                                },
                                [
                                  _vm.getButtonIcon(btn)
                                    ? _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v(_vm._s(_vm.getButtonIcon(btn)))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(btn.text))]),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.infoText
        ? _c("div", { staticClass: "waba-info-bar" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("info_outline"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.infoText))]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "waba-lto-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("card_giftcard")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }